module.exports = __webpack_public_path__ + "static/media/3-kjask.7cb00e95.mp3";